import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { copyToClipboard } from "@/shared/utils/copyToClipboard";
import "./styles/CopyableOrderId.scss";

interface CopyableOrderIdProps {
  orderId: string;
  prefix?: string;
  className?: string;
}

const formatOrderId = (orderId: string): string => {
  if (orderId.length <= 18) {
    return orderId;
  }
  return `${orderId.slice(0, 8)}…${orderId.slice(-6)}`;
};

export const CopyableOrderId: React.FC<CopyableOrderIdProps> = ({
  orderId,
  prefix = "Заказ",
  className = "",
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const success = await copyToClipboard(orderId);
    if (!success) return;
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      className={`copyable-order-id ${className}`.trim()}
      onClick={(event) => void handleCopy(event)}
      title={`Скопировать ID: ${orderId}`}
      aria-label={`Скопировать ID заказа ${orderId}`}
    >
      <span className="copyable-order-id__text">
        {prefix} #{formatOrderId(orderId)}
      </span>
      <span className="copyable-order-id__icon" aria-hidden="true">
        {copied ? <CheckIcon fontSize="inherit" /> : <ContentCopyIcon fontSize="inherit" />}
      </span>
      {copied && <span className="copyable-order-id__feedback">Скопировано</span>}
    </button>
  );
};
